import React from "react";
import { useLocation } from "react-router-dom";
import classNames from "../../classNames";
import Child from "./Child";

const defaultIcon = "bi bi-journal-text";
const defaultProps = {
  onClick: () => {},
};

function Item({ menu, onClick, logout }) {
  const { name, icon, label, disabled, route, isParent } = menu;
  const location = useLocation();
  const isCurrentRoute = location.pathname === route;

  if (Array.isArray(route)) {
    const isChildRouteActive = route.some((childMenu) =>
      location.pathname.startsWith(childMenu.route)
    );
    return (
      <Child
        key={menu.name}
        menu={menu}
        onClick={onClick}
        isParentActive={isChildRouteActive}
      />
    );
  }

  const handleClick = (e) => {
    onClick(e, menu);
    if (name === "Logout") {
      logout();
    }
  };

  const handleMouseEnter = (e) => {
    e.currentTarget.style.backgroundColor = isParent
      ? "rgba(41, 69, 124, 1)"
      : isCurrentRoute
      ? "#1d4d8b"
      : "rgba(41, 69, 124, 1)";
    e.currentTarget.style.color = isParent
      ? "rgba(255, 255, 255, 0.80)"
      : isCurrentRoute
      ? "white"
      : "rgba(255, 255, 255, 0.80)";
  };

  const handleMouseLeave = (e) => {
    e.currentTarget.style.backgroundColor = isCurrentRoute
      ? "#2a447c"
      : "transparent";
    e.currentTarget.style.color = isParent
      ? "rgba(255, 255, 255, 0.65)"
      : isCurrentRoute
      ? "white"
      : "#2a447c";
  };

  return (
    <>
      {name === "My Profile" && (
        <div
          style={{
            height: "1px",
            backgroundColor: "#e8e8e8",
            margin: "15px 0",
          }}
        />
      )}
      <li className="nav-item" key={route}>
        <a
          onClick={handleClick}
          href={route}
          className={classNames(
            "nav-link text-truncate",
            disabled ? "disabled" : ""
          )}
          style={{
            margin: isParent ? "0" : "5px 0",
            padding: isParent
              ? "1rem 1.5rem"
              : isCurrentRoute
              ? ".2rem 3rem"
              : ".5rem 3rem",
            color: isParent
              ? "rgba(255, 255, 255, 0.65)"
              : isCurrentRoute
              ? "white"
              : "#2a447c",
            backgroundColor: isCurrentRoute ? "#2a447c" : "",
          }}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <div>
            <i
              className={icon || defaultIcon}
              style={{
                zoom: isParent ? "0" : isCurrentRoute ? "1.8" : "0",
                transition: isCurrentRoute ? "zoom .5s ease-in-out" : "",
                color: isParent
                  ? "rgba(255, 255, 255, 0.65)"
                  : isCurrentRoute && "rgb(40, 136, 228)",
              }}
            ></i>
            <span className="ms-2">{label || name}</span>
          </div>
        </a>
      </li>
    </>
  );
}

Item.defaultProps = defaultProps;
export default Item;
